import { getBoardId } from '@/core/web-storage/webStorage.utils';
import { baseAppApi } from '@/core/network/baseAppApi';
import { COMMON_HEADERS } from '@/core/network/network.constants';
import { ValidEmployeeStatuses } from '@/common/common.types';
import { getFirstErrorOrDefault } from '@/core/network/network.utils';
import tokens from '@/reports/tokens.json';

interface EmployeePrintRequest {
  schoolYear: string;
  sin: string;
  includeDR: boolean;
}

export interface EmployeeContributionDetails {
  employerId: number;
  employeeId: number;
  contributionId: number;
  employmentMonth: string;
  effectiveDateOfRecord: string;
  schoolYear: string;
  recordType: string;
  specialCode: string;
  statusCode: string;
  fte: number;
  fteDaysPaid: number;
  fteDaysMissed: number;
  totalOperationalDaysYear: number;
  totalOperationalDaysMonth: number;
  multipleContractId: string;
  ftMonthlyRateOfSalary: number;
  ptMonthlyRateOfSalary: number;
  pensionableSalaryPaid: number;
  employeeContributions: number;
  ataFees: number;
  signingBonusAmount: number;
  allowanceAmount: number;
}

export interface EmployeeContributionTotals {
  totalDays: number;
  totalNonSubstitutePSP: number;
  totalSubstituteSalary: number;
  totalContributions: number;
  totalSalary: number;
  totalATAFees: number;
}

export interface EmployeePrintResponse {
  firstName: string;
  lastName: string;
  sin: string;
  schoolCode: string;
  dateOfBirth: string;
  employerEmployeeNumber: string;
  teachingCertificateNumber: string;
  streetAddress: string;
  city: string;
  province: string;
  postalCode: string;
  phoneNumber: string;
  faxNumber: string;
  emailAddress: string;
  terminationStatus: ValidEmployeeStatuses;
  terminationDate: null | string;
  ataLocal: number;
  contributionDetails: EmployeeContributionDetails[];
  contributionTotals: EmployeeContributionTotals;
}

export interface ErrorType {
  exceptionMessage: string;
  context: string;
}

export interface GetEmployeePrintResponse {
  data: EmployeePrintResponse;
  errors: ErrorType[];
}

const employeePrintApi = baseAppApi.injectEndpoints({
  endpoints: (build) => ({
    getEmployeePrintReport: build.mutation<EmployeePrintResponse, EmployeePrintRequest>({
      query(body) {
        const boardId = getBoardId();
        return {
          url: `v1/employers/${boardId}/reports/employeeprint`,
          body: body,
          method: 'POST',
          headers: COMMON_HEADERS,
        };
      },
      transformErrorResponse(response) {
        return getFirstErrorOrDefault(response, tokens['BANNER_ERROR']);
      },
    }),
  }),
  overrideExisting: false,
});

export { employeePrintApi };
